import * as React from 'react';
import { ScoredSelectionStats, SurveyTopic, UnscoredSelectionStats } from '../../../amorg-common';
import { Card } from '../../../designSystem/Card';
import { Flex, FlexItem } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Em } from '../../../designSystem/typography/Em';
import { AggregatedSurveyAnswerScoreRadialChart, SurveyQuestionAnswerScoreRadialChart } from '../../../designSystem/graphs/SurveyAnswerScoreRadialChart';
import { AggregatedSurveyAnswerRatioBar, QuestionSurveyAnswerRatioBar } from '../../workplaceassessments/[activityId]/_components/tabs/report/_components/SurveyAnswerRatioBar';

type SurveyTopicInfoPanelProps = {
    surveyTopic: SurveyTopic
}
export function SurveyTopicInfoPanel(props:SurveyTopicInfoPanelProps):JSX.Element
{
    const stats = props.surveyTopic.data.scoreMap === null
        ? new UnscoredSelectionStats(props.surveyTopic.data.selections)
        : new ScoredSelectionStats(props.surveyTopic.data.selections, props.surveyTopic.data.scoreMap);


    const topicTitle = props.surveyTopic.data.title;
    let answerCount = stats.totalSelections || 0;

    if(answerCount > 0){
        if(props.surveyTopic.linkType === 'theme'){
            const questionsInTheme = props.surveyTopic.questionsInTheme
            answerCount = answerCount / questionsInTheme;
        }
        else if(props.surveyTopic.linkType === 'indicator'){
            const questionsWithIndicator = props.surveyTopic.questionsWithIndicator;
            answerCount = answerCount / questionsWithIndicator;
        }
        else if(props.surveyTopic.linkType === 'question'){
            // answerCount = answerCount;
        }
            
    }

    let topicText = <></>;

    if(props.surveyTopic.linkType === 'theme')
        topicText = 
            <span>
                Emnet vedrører temaet <Em>{topicTitle}</Em> fra spørgeskemaet. Temaet indeholder <Em>{props.surveyTopic.questionsInTheme} spørgsmål</Em>.
            </span>;

    else if(props.surveyTopic.linkType === 'indicator')
        topicText = 
            <span>Emnet vedrører indikatoren <Em>{topicTitle}</Em> fra spørgeskemaet. Indikatoren er tilknyttet <Em>{props.surveyTopic.questionsWithIndicator} spørgsmål</Em>.
            </span>;

    else if(props.surveyTopic.linkType === 'question')
        topicText = 
            <span>Emnet vedrører spørgsmålet <Em>{topicTitle}</Em> fra spørgeskemaet
            </span>;

    return (
        <>
            {props.surveyTopic &&
                <Flex flexDirection="row">
                    <FlexItem>
                        {(props.surveyTopic.linkType === 'theme' || props.surveyTopic.linkType === 'indicator') &&
                            <AggregatedSurveyAnswerScoreRadialChart stats={stats} />
                        }

                        {props.surveyTopic.linkType === 'question' &&
                            <SurveyQuestionAnswerScoreRadialChart question={props.surveyTopic.question} stats={stats} />
                        }
                    </FlexItem>
                    <Flex flexDirection="column" gap={8}>
                        <Card variant="outlined">
                             <small>
                                 {topicText}
                             </small>
                        </Card>
                        {(props.surveyTopic.linkType === 'theme' || props.surveyTopic.linkType === 'indicator') &&
                            <AggregatedSurveyAnswerRatioBar stats={stats as ScoredSelectionStats} />
                        }
                        {props.surveyTopic.linkType === 'question' &&
                            <QuestionSurveyAnswerRatioBar question={props.surveyTopic.question} stats={stats} />
                        }
                    </Flex>
                </Flex>
            }
        </>
    );
}